import PropTypes from 'prop-types';
import React from 'react';
import Link from 'app/common/components/link';
import _ from 'lodash';

/**
 * NavigationItem is used to render a navigation tab.
 * See ./config for tab (route) definitions
 */
const NavigationItem = ({ tab, onClick, className }) => {
  const {
    disabled,
    secondary,
    separator,
    local,
    url,
    text,
    openInNewTab,
  } = tab || {};

  if (disabled || secondary) return null;

  let item = null;
  if (separator) {
    item = <hr className='navSeparator' />;
  } else if (local) {
    item = (
      <Link className={className} to={url} activeClassName='active' onClick={onClick}>
        {text}
      </Link>
    );
  } else {
    item = (
      <a
        className={className}
        href={url}
        target={openInNewTab ? '_blank' : '_self'}
        onClick={onClick} >
        {text}
      </a>
    );
  }

  return item;
};

NavigationItem.propTypes = {
  tab: PropTypes.shape({
    separator: PropTypes.bool,
    local: PropTypes.bool,
    url: PropTypes.string,
    text: PropTypes.string,
    openInNewTab: PropTypes.bool,
  }).isRequired,
  disabled: PropTypes.bool,
  secondary: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.oneOf([
    'clearLink',
  ]),
};

NavigationItem.defaultProps = {
  onClick: _.noop,
  disabled: false,
  secondary: false,
  className: null,
};

export default NavigationItem;



// WEBPACK FOOTER //
// ./app/common/components/navigation/navigation-item.jsx